import {
    styled,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

import { api } from '../../../lib/api';
import { Section } from '../../../components/Section';
import { Query } from '../../../components/Query';
import { Button } from '../../../components/Button';

function FormationInitialeEntryForm(props: { id: string }) {
    return (
        <MainContainer>
            <HeaderContainer className="not-printable">
                <Button
                    fullWidth
                    startIcon={<PrintIcon />}
                    variant="contained"
                    onClick={handlePrint}
                >
                    Imprimer
                </Button>
            </HeaderContainer>
            <Query
                queryKey={['formation-initiale-entries', props.id]}
                apiCall={() => api.getFormationInitiale(props.id)}
            >
                {(formationInitialeEntry) => (
                    <>
                        <Row>
                            <LabelText variant="h3">Candidature en :</LabelText>
                            <ValueText variant="h3">
                                {formationInitialeEntry.selectedPromo}
                            </ValueText>
                        </Row>
                        <Section variant="h2" title="Informations personnelles">
                            <Row>
                                <LabelText>Nom :</LabelText>
                                <ValueText>
                                    {formationInitialeEntry.firstName}{' '}
                                    {formationInitialeEntry.lastName}
                                </ValueText>
                            </Row>
                            <Row>
                                <LabelText>Genre : </LabelText>
                                <ValueText>{formationInitialeEntry.gender}</ValueText>
                            </Row>

                            <Row>
                                <LabelText>Date de naissance :</LabelText>
                                <ValueText>{formationInitialeEntry.birthdate}</ValueText>
                            </Row>
                            <Row>
                                <LabelText>Nationalité / Lieu de naissance : </LabelText>
                                <ValueText>{formationInitialeEntry.nationality}</ValueText>
                            </Row>
                            <Row>
                                <LabelText>Contact : </LabelText>
                                <ValueText>
                                    {formationInitialeEntry.email} -{' '}
                                    {formationInitialeEntry.phoneNumber}
                                </ValueText>
                            </Row>
                            <Row>
                                <LabelText>Adresse : </LabelText>
                                <ValueText>{formationInitialeEntry.address}</ValueText>
                            </Row>
                        </Section>
                        <Section variant="h2" title="Parcours">
                            <Row>
                                <LabelText>
                                    Diplôme en cours d'acquisition ou dernier diplôme obtenu :
                                </LabelText>
                                <ValueText>{formationInitialeEntry.lastDiploma}</ValueText>
                            </Row>
                            {!!formationInitialeEntry.otherDiploma && (
                                <Row>
                                    <LabelText>Autre diplôme :</LabelText>
                                    <ValueText>{formationInitialeEntry.otherDiploma}</ValueText>
                                </Row>
                            )}
                            {!!formationInitialeEntry.previousProfession && (
                                <Row>
                                    <LabelText>Profession exercée :</LabelText>
                                    <ValueText>
                                        {formationInitialeEntry.previousProfession}
                                    </ValueText>
                                </Row>
                            )}
                            <Row>
                                <LabelText></LabelText>
                                <ValueText></ValueText>
                            </Row>
                            <Row>
                                <LabelText></LabelText>
                                <ValueText></ValueText>
                            </Row>
                        </Section>
                        <Section variant="h2" title="Parents ou tuteurs">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <Typography>Premier parent ou tuteur</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>Deuxième parent ou tuteur</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            <ValueText>
                                                {formationInitialeEntry.parent1Name}
                                            </ValueText>
                                        </TableCell>
                                        <TableCell>
                                            <ValueText>
                                                {formationInitialeEntry.parent2Name}
                                            </ValueText>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <ValueText>
                                                {formationInitialeEntry.parent1Address}
                                            </ValueText>
                                        </TableCell>
                                        <TableCell>
                                            <ValueText>
                                                {formationInitialeEntry.parent2Address}
                                            </ValueText>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <ValueText>
                                                {formationInitialeEntry.parent1Contact}
                                            </ValueText>
                                        </TableCell>
                                        <TableCell>
                                            <ValueText>
                                                {formationInitialeEntry.parent2Contact}
                                            </ValueText>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Section>
                        <Section variant="h2" title="Motivation">
                            <ValueText>{formationInitialeEntry.motivation}</ValueText>
                        </Section>
                        <Section variant="h2" title="Comment avez-vous connu l'ésaj ?">
                            <ValueText>{formationInitialeEntry.reference}</ValueText>
                        </Section>
                    </>
                )}
            </Query>
        </MainContainer>
    );

    function handlePrint() {
        window.print();
    }
}

const MainContainer = styled('div')(({ theme }) => ({ width: '100%' }));

const Row = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));

const ValueText = styled(Typography)(({ theme }) => ({ fontWeight: 'bold' }));
const LabelText = styled(Typography)(({ theme }) => ({ marginRight: theme.spacing(1) }));

const HeaderContainer = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
}));
export { FormationInitialeEntryForm };
